import { useState } from "react";
import Grid from "@mui/material/Grid";
import { addOrganisation } from "../../app/services/OrganisationService";
import { fetchStates, States } from "../../app/services/StatesService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import FormInput from "../../app/shared/common/form/FormInput";
import FormPageWrapper from "../../app/shared/common/form/FormPageWrapper";
import ResetSubmitButton from "../../app/shared/common/form/ResetSubmitButton";
import FormDropDown from "../../app/shared/common/form/FormDropDown";
import { handleInputChange } from "../../app/helpers/validations";
const typeInv = [
  {
    id: 0,
    name: "Delivery Challan",
  },
  {
    id: 1,
    name: "Invoice",
  },
];
const AddOrganisation = () => {
  const navigate = useNavigate();
  const [loading,setLoading] = useState(false);
  const [name, setName] = useState("");
  const [legalName, setLegalName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [secmobile, setSecMobile] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [landMark, setLandMark] = useState("");
  const [is_inv, setIsInv] = useState("0");
  const [stateList, setStateList] = useState<States[]>([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const handleReset = () => {
    setName("");
    setLegalName("");
    setEmail("");
    setMobile("");
    setSecMobile("");
    setPanNumber("");
    setGstNumber("");
    setAddress("");
    setPincode("");
    setLandMark("");
  };

  const handleSubmit = async () => {
    if (!name.trim()) {
      toast("Name is required");
      return;
    }
    if (!legalName.trim()) {
      toast("Legal name is required");
      return;
    }
    if (!email.trim()) {
      toast("Email is required");
      return;
    }
    if (mobile.trim().length != 10) {
      toast("Valid Mobile is required");
      return;
    }
    // if (panNumber.trim().length != 10) {
    //   toast("Valid Pan number is required");
    //   return;
    // }
    // if (!gstNumber.trim()) {
    //   toast("Gst number is required");
    //   return;
    // }
    if (!address.trim()) {
      toast("Address is required");
      return;
    }
    if (pincode.trim().length!=6) {
      toast("Valid Pincode is required");
      return;
    }
    if (!selectedState) {
      toast("State is required");
      return;
    }
    if (!selectedCity) {
      toast("City is required");
      return;
    }
    const payload = {
      name,
      legalname: legalName,
      email,
      mobile,
      secondary_mobile: secmobile,
      pan_number: panNumber,
      gst_number: gstNumber,
      address,
      pin_code: pincode,
      is_inv: is_inv == "0" ? false : true,
      stateid: Number(selectedState),
      city: selectedCity,
      land_mark: landMark,
      lat: "21.0760",
      long: "52.8777",
    };

    try {
      setLoading(true);
      const response = await addOrganisation(payload);
      
      if (response.status === "success") {
        toast.success("Organisation saved successfully!");
        handleReset();
        navigate("/organisation");
      } else {
        toast.error(response.message);
      }
    } catch (error:any) {
       const errMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to save organisation details.";
      toast.error(errMsg);
    }finally{
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadStates = async () => {
      try {
        const res = await fetchStates();
        if (res.status === "success") {
          setStateList(res.data);
        }
      } catch (err) {
        toast("Failed to load states");
      }
    };

    loadStates();
  }, []);

  return (
    <FormPageWrapper title="Add New Organisation">
      <FormInput
        label={"Name"}
        value={name}
        onChange={(e) => handleInputChange(e, "name", setName)}
        required
      />
      <FormInput
        label={"Legal Name"}
        value={legalName}
        onChange={(e) => handleInputChange(e, "name", setLegalName)}
        required
      />
      <FormInput
        label={"Email"}
        value={email}
        onChange={(e) => handleInputChange(e, "email", setEmail)}
        required
      />
      <FormInput
        label={"Mobile"}
        value={mobile}
        onChange={(e) => handleInputChange(e, "mobile", setMobile)}
        required
      />

      <FormInput
        label={"Secondary Mobile"}
        value={secmobile}
        onChange={(e) => handleInputChange(e, "mobile", setSecMobile)}
      />

      <FormInput
        label={"Pan Number"}
        value={panNumber}
        onChange={(e) => handleInputChange(e, "pan", setPanNumber)}
        
      />

      <FormInput
        label={"Gst Number"}
        value={gstNumber}
        onChange={(e) => handleInputChange(e, "gst", setGstNumber)}
        
      />
      <FormInput
        label={"Address"}
        value={address}
        onChange={(e) => handleInputChange(e, "address", setAddress)}
        required
      />

      <FormDropDown
        label="Select State"
        value={selectedState}
        onChange={setSelectedState}
        options={stateList}
        allLabel="Select State"
      />

      <FormInput
        label={"City"}
        value={selectedCity}
        onChange={(e) => handleInputChange(e, "address", setSelectedCity)}
        required
      />

      <FormDropDown
        label="Select Type"
        value={is_inv}
        onChange={setIsInv}
        options={typeInv}
        allLabel="Select Type"
      />

      <FormInput
        label={"Pincode"}
        value={pincode}
        onChange={(e) => handleInputChange(e, "pincode", setPincode)}
        required
      />

      <FormInput
        label={"Landmark"}
        value={landMark}
        onChange={(e) => handleInputChange(e, "address", setLandMark)}
      />

      <ResetSubmitButton onReset={handleReset} onSubmit={handleSubmit} loading={loading}/>
    </FormPageWrapper>
  );
};

export default AddOrganisation;
